<!-- /**
* 作用于哪些页面
* 注明代码业务/功能说明
* @authors zzt
* @date 2019-04-16
* @version 1.0.0

*/ -->

<template>
  <div class="submit-search-box">
    <div class="submit-search-inner">
      <el-input
        :placeholder="placeholder"
        v-model="query"
        @input="input"
        @focus="focus();showSearch=true"
        @blur="onBlur();showSearch=false"
        @keyup.native="selectDown"
        ref="searchInner"
      >
        <i
          slot="suffix"
          v-show="query"
          @click="query=''"
          class="el-input__icon el-icon-error err-style"
        ></i>
        <div slot="append">
          <!-- <el-button class="searchbuttom font24" @click="search">
            <i class="el-icon-search font24"></i>
          </el-button> -->
          <el-button class="searchbuttom font16" @click="search">
            搜索
          </el-button>
        </div>
      </el-input>
    </div>
    <div class="search_list" v-if="searchList.length > 0">
      <ul v-if="searchList.length > 0">
        <li
          v-for="(item, index) in searchList"
          class=" cursor"
          :key="index"
          @click.stop="clickList(item)"
          :class="{ hover: searchStyleList[index] }"
          @mouseover="selectStyle(index)"
          @mouseout="changeStyle(index)"
          v-html="spliceSearchList(item)"
        ></li>
      </ul>
    </div>
<!--    <div class="search-recommend" v-show="query&&showSearch">
      <div class="search-recommend-inner" style="width: 100%">
        <div class="tc-10"></div>
        <div class="search-recommend-title">推荐搜索</div>
        <div class="tc-10"></div>
        <div class="tc-5"></div>
        <div class="search-recommend-right">
          <div
            v-show="index < 10"
            class="cursor"
            :class="{ colorfe: index < 3 }"
            v-for="(item, index) in seachList"
            @click="clickList(item.title)"
            :key="index"
          >
            {{ index + 1 }}.{{ item.title }}
          </div>
        </div>
      </div>
    </div>-->
    <div class="search-recommend" v-show="showRecommend">
      <div class="search-recommend-inner">
        <div class="tc-10"></div>
        <div class="search-recommend-title">
          最近搜索
          <div v-if="recentlySearchList&&recentlySearchList.length" @click="deletedSearchList">
            <img src="@/assets/delete.png" alt="" />
          </div>
        </div>
        <div class="tc-10"></div>
        <div class="tc-5"></div>
        <div
          class="search-recommend-left"
          v-if="recentlySearchList.length == 0"
        >
          <div class="search-img-search-no">
            <img src="@/assets/search-no.png" alt="" />
          </div>
          <div class="tc-10"></div>
          <div class="tc-5"></div>
          <p class="search-img-search-no-font">您最近没有搜索过</p>
        </div>
        <div
          class="search-recommend-right search-recommend-left"
          v-if="recentlySearchList.length > 0"
        >
          <div
            @click="clickList(item)"
            v-show="index < 10"
            class="cursor"
            v-for="(item, index) in recentlySearchList"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="search-recommend-inner">
        <div class="tc-10"></div>
        <div class="search-recommend-title">热门搜索</div>
        <div class="tc-10"></div>
        <div class="tc-5"></div>
        <div class="search-recommend-right">
          <div
            @click="clickList(item)"
            v-show="index < 10"
            class="cursor"
            :class="{ colorfe: index < 3 }"
            v-for="(item, index) in hotKey"
            :key="index"
          >
            {{ index + 1 }}.{{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import localStorage from "@/storage/localStorage"
import { apiHome } from "@/api/apiHome"
import apiSearch from "@/api/apiSearch"
import EventBus from "@/util/event-bus"
import {debounce} from "@/utils/debounce"


export default {
  name: "SubmitSearch",
  mixins: [],
  extends: {},
  props: {},
  data() {
    return {
      initPlaceholder: "无输入关键字",
      placeholder: '搜索关键词，如"经营帮"',
      query: "",
      searchList: [],
      num: "",
      searchStyleList: [],
      hotKey: [],
      showRecommend: false,
      showSearch:false,
      recentlySearchList: [], // 最近搜索记录
      hoverIndex: null,
      seachList:[],
    }
  },
  computed: {},
  components: {},
  filter: {},
  watch: {
    query(v){
      if(v){
        //this.getSeach();
      }
    }
  },
  inject: ["reload"],
  methods: {
    outBlur() {
      this.$refs["searchInner"].blur();
    },
    getSeach:debounce(function(v){
      if(!this.query)return;
      apiHome.getSeach({keyword:this.query,type:'gongdui'}).then(res=>{
        if(res.data.code==200){
          //{id: 0, title: "11.25°双承弯管", type: "shangpin"}
          this.seachList=res.data.data;
        }
      })
    },500),
    spliceSearchList(item) {
      let string = item
      // let num = this.query.length
      // if(this.query == string.substring(0,this.query.length)){
      //   string = this.query+ '<span style="font-weight: bold;">'+string.substring(num,item.length) +'</span>'
      // }
      return string
    },
    input() {
      this.searchList = []
      if (this.query === "") {
        this.showRecommend = true
      } else {
        this.showRecommend = false
      }
      if (this.query.length > 50) {
        this.query = this.query.slice(0, 50)
      }
    },
    focus() {
      // 获取焦点
      if (this.query === "") {
        // 搜索词为空  打开推荐词
        // this.query = this.placeholder
        // this.placeholder = this.initPlaceholder
        this.showRecommend = true
      } else {
        // this.placeholder = this.query
        // this.query = ''
        this.showRecommend = false
      }
      // this.showRecommend = true
    },
    onBlur() {
      let that = this
      setTimeout(function() {
        that.searchList = []
        that.showRecommend = false
      }, 200)
    },
    getSearchList() {
      this.recentlySearchList = []
      let List = localStorage.read("searchList")
      if (List === null) {
        List = []
      } else {
        List = JSON.parse(List)
      }
      this.recentlySearchList = List
    },
    deletedSearchList() {
      localStorage.clear("searchList")
      this.getSearchList()
    },
    setSearchList() {
      // 校验是否为空
      var regu = "^[ ]+$"
      var re = new RegExp(regu)
      let bol = re.test(this.query)
      if (this.query === "" || bol) {
        return
      }
      // 如果有历史搜索  则提前
      let index = this.recentlySearchList.indexOf(this.query)
      if (index !== -1) {
        this.recentlySearchList.splice(index, 1)
      }
      this.recentlySearchList.unshift(this.query)
      // 删除多余元素  只保留十个
      while (this.recentlySearchList.length > 10) {
        this.recentlySearchList.pop()
      }
      let List = JSON.stringify(this.recentlySearchList)
      localStorage.set("searchList", List)
    },
    selectStyle(index) {
      this.hoverIndex = index
      this.changeStyle()
      this.searchStyleList.splice(index, 1, true)
    },
    async selectDown() {
      let key = window.event.keyCode
      switch (key) {
        case 13:
          this.search()
          return
        case 38:
          this.monitorOnkeydown(38)
          return
        case 40:
          this.monitorOnkeydown(40)
          return
      }

      let obj = {}
      obj.page = 1
      obj.limit = 10
      obj.words = this.query
      //查询搜索记录
      //let res = await apiSearch.keywords(obj)
      // let data = await apiHome.searchPrompt(this.query);
      //this.searchList = res.data.data
      this.hoverIndex = null

      this.initSearchStyleList()
    },
    changeStyle() {
      // 初始化
      // hover清空
      for (let i = 0; i < this.searchStyleList.length; i++) {
        this.searchStyleList.splice(i, 1, false)
      }
    },
    initSearchStyleList() {
      // 初始化搜索选择列表
      this.searchStyleList = []
      for (let i = 0; i < this.searchList.length; i++) {
        this.searchStyleList.push(false)
      }
    },
    async getHotKey() {
      // 热门搜索词
      let res = await apiHome.getHotKey()
      this.hotKey = res.data
      /*
      //搜索框显示搜索历史
      if (localStorage.read("search_query") !== null) {
        this.placeholder = localStorage.read("search_query")
        return
      }*/
      //搜索框显示热门搜索词
      if (this.query === "") {
        this.placeholder = this.hotKey[0]
      }

      if (this.$route.path === "/searchResult") {
        this.query = localStorage.read("search_query")
        return
      }
    },
    monitorOnkeydown(key) {
      // 设置键盘监听
      let num = 1
      let index
      switch (key) {
        case 38:
          num *= -1
          break
        case 40:
          num *= 1
          break
      }
      if (this.hoverIndex === null) {
        index = 0
        if (num === 1) {
          this.selectStyle(0)
        }
        if (num === -1) {
          this.selectStyle(this.searchStyleList.length - 1)
        }
        return
      } else {
        index = this.hoverIndex + num
      }
      let max = this.searchStyleList.length

      switch (index) {
        case -1:
          index = this.searchStyleList.length - 1
          break
        case max:
          index = 0
          break
        default:
          break
      }
      this.query = this.searchList[index]
      this.selectStyle(index)
    },
    clickList(code) {
      //
      this.query = code
      this.showRecommend = false

      this.searchList = []
      this.search()
    },
    search() {

      if (this.query.trim() === "") {
        this.$message.warning('请输入关键词后进行搜索')
        return;
        //无输入时填充本地搜索历史或 热门词
        /*
        let localStorage1 = localStorage.read("search_query")
        if (localStorage1 === null) {
          this.query = this.placeholder
        } else {
          this.query = localStorage1
          if (this.$route.path === "/searchResult") {
            return
          }
        }*/
      }

      this.searchList = []
      this.setSearchList()
      // let ss = this.regx(this.query);
      let ss = true
      if (ss) {
        localStorage.set("search_query", this.query)

        //埋点开始
        new Probe({
          plateform: "pc",
          module: "gongdui",
          url: `${process.env.VUE_APP_BURYINGPOINT}/v3/behaviout/log`,
          source: "jyb",
        }).search(this.query)
        //埋点结束
        if (this.$route.path === "/searchResult") {
          this.reload()
          //this.$router.go(0)
        } else {
          this.$router.push({ path: "/searchResult" })
        }
      }
    },
    regx(newName) {
      // var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
      //     regCn = /[·！#￥\s（——）：；“”‘、，|《。》？、【】[\]]/im;
      let regEn = /[`~!@$%^&*_+<>?:"{},/;'[\]]/im;
      let regCn = /[·！￥——：；“”‘、，|《。》？、【】[\]]/im
      if (regEn.test(newName) || regCn.test(newName)) {
        return false
      } else {
        return true
      }
    }
  },
  created() {
    this.getSearchList()
    this.getHotKey()
    EventBus.$on("reload", () => {
      localStorage.clear("search_query")
      this.query = ""
    })
  },

  mounted() {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
// @media  screen and (min-width:1218px){}
// @media  screen and (max-width:1217px){}
// @media  screen and (max-width:992px){}
@import "~@/styles/static-style";
.submit-search-box {
  width: 520px;
  height: 40px;
  margin-right: 20px;
  position: relative;
  // border-radius: 4px;
  // -webkit-box-shadow: -3px 3px 20px 0 #e1e1e1, -3px -3px 20px 0 #e1e1e1;
  // box-shadow: -3px 3px 20px 0 #e1e1e1, -3px -3px 20px 0 #e1e1e1;
  // overflow: hidden;
  .searchbuttom {
    width: 80px;
    // border-radius: 0 4px 4px 0;
    // overflow: hidden;
    height: 40px;
    line-height: 32px;
    margin: 0 -20px;
    font-size: 16px;
    padding: 0;
  }
  .el-icon-search {
    font-size: 24px;
    // line-height: 40px;
  }
  .submit-search-inner {
    width: 100%;
    height: 100%;
    > div {
      float: left;
    }
  }
  .search_list,
  .search-recommend {
    width: 476px;
    background: #fff;
    border: 1px solid rgba(223, 228, 234, 1);
    z-index: 101;
    position: absolute;
    top: 40px;
  }
  .search_list {
    ul {
      margin: 0;
    }
    .hover {
      background: rgba(0, 0, 0, 0.03);
    }
    li {
      font-size: 14px;
      text-indent: 15px;
      height: 30px;
      line-height: 30px;
      span {
        font-weight: bold;
      }
    }
  }
  .search-recommend {
    // border-radius: 0 0 4px 4px;
    // position: relative;
    z-index: 101;
    min-height: 216px;
    .search-recommend-inner {
      &:nth-child(1) {
        border-right: 1px solid rgba(223, 228, 234, 1);
      }
      vertical-align: top;
      display: inline-block;
      width: 49%;
      min-height: 216px;
      .search-recommend-title {
        text-indent: 11px;
        color: #333;
        font-size: 14px;
        font-weight: bold;
        position: relative;
        > div {
          width: 12px;
          height: 14px;
          position: absolute;
          right: 5px;
          top: 3px;
          > img {
            width: 100%;
            height: 100%;
            float: left;
          }
        }
      }

      .search-recommend-left {
        .search-img-search-no {
          width: 101px;
          height: 85px;
          margin: 0 auto;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        .search-img-search-no-font {
          font-size: 12px;
          color: #666666;
          text-align: center;
        }
      }
      .search-recommend-right {
        font-size: 12px;
        padding-left: 10px;
        .colorfe {
          color: #fe4e00;
        }
        > div {
          max-width: 7em;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          padding: 4px 10px;
          display: inline-block;
          margin: 0 10px 10px 0;
          background: rgba(0, 0, 0, 0.05);
          color: #666;
        }
      }
      .search-recommend-left{
        >div{
          max-width: 6em;
        }
      }
    }
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.submit-search-box {
  .el-input-group__append {
    // background-color: #0286df;
    background-color: #e1251b;
    color: #ffffff;
    border: 0 solid #dcdfe6;
    border-radius: 0;
    // border-radius: 0;
    padding: 0;
    width: 84px;
    font-size: 18px;
    text-align: center;
  }
  .el-input__inner {
    border-radius: 0;
  }
  .el-input__inner:focus {
    border-color: #e1251b;
  }
}
</style>
